import { useMemo } from 'react';

import {
  PreparedWorkload,
  useWoopWorkloadFilters,
} from 'features/workload-optimization';

import {
  kindCriterion,
  namespaceCriterion,
} from '../../../_workloads-list/searchCriteria';
import {
  configuredViaCriterion,
  horizontalOptimizationCriterion,
  verticalOptimizationCriterion,
} from '../../../workloads-list/searchCriteria';

import { makeSearchBoxCriteria } from '@cast/shared-search-ui';

type Options = {
  // Adds a "Workload type" option to the search box. Opt-in so other callers
  // (impact WorkloadsSection default, predictive drawer) stay unchanged.
  includeWorkloadTypeInSearchBox?: boolean;
};

export const useImpactWorkloadsCriteria = (options: Options = {}) => {
  const { data } = useWoopWorkloadFilters({ optimizedOnly: true });
  const { includeWorkloadTypeInSearchBox = false } = options;

  return useMemo(
    () => [
      ...makeSearchBoxCriteria<PreparedWorkload>(
        {
          key: 'workloadId',
          title: 'Workload ID:',
          prop: 'id',
          options: data?.workloadIds ?? [],
          allowMultiple: true,
        },
        {
          key: 'workloadName',
          title: 'Workload name:',
          prop: 'name',
          options: data?.workloadNames ?? [],
          allowMultiple: true,
          matcher: 'exact',
        },
        includeWorkloadTypeInSearchBox && {
          title: 'Workload type:',
          key: 'kind',
          prop: 'kind',
          options: data?.kinds ?? [],
          allowMultiple: true,
          matcher: 'exact',
        }
      ),
      namespaceCriterion,
      kindCriterion,
      configuredViaCriterion,
      verticalOptimizationCriterion,
      horizontalOptimizationCriterion,
    ],
    [data, includeWorkloadTypeInSearchBox]
  );
};
